export default function StatusBadge({ status }) {
  const tones = {
    pending: "bg-amber-100 text-amber-800",
    confirmed: "bg-teal/10 text-teal",
    cancelled: "bg-ink/10 text-ink/50",
    completed: "bg-emerald-100 text-emerald-800",
    new: "bg-amber-100 text-amber-800",
    contacted: "bg-sky-100 text-sky-800",
    declined: "bg-ink/10 text-ink/50",
  };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold capitalize ${tones[status] || "bg-ink/10 text-ink/60"}`}
    >
      {status}
    </span>
  );
}
